module.exports = __webpack_public_path__ + "media/img/pages/companies/hslu-en-e8d5c8d211b5b06e4507713bc261f594.webp";